import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lincs-icon.png'
import _imports_1 from '@/assets/documentation.svg'
import _imports_2 from '@/assets/exitExtension.svg'


const _hoisted_1 = {
  id: "header",
  class: "header-block",
  role: "banner"
}
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "LINCS logo"
}, null, -1)
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "info-tag" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "info-link",
    href: "https://lincsproject.ca/docs/tools/context-explorer/",
    target: "_blank",
    title: "Documentation"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "documentation",
      src: _imports_1,
      alt: "Link to Documentation"
    })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Exit extension",
  style: {"width":"100%","height":"100%"}
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("SidePanelHeader.context_explorer")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("button", {
        class: "exit-extension",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitExtension && _ctx.exitExtension(...args))),
        "aria-label": "Exit Context Explorer",
        title: "Exit Context Explorer"
      }, _hoisted_8)
    ])
  ]))
}